import React from "react";
import { Grid } from "@material-ui/core";
import { connect as reduxConnect } from "react-redux";
import { connect } from "formik";
import { compose } from "redux";
import _ from "lodash";
import styled from "styled-components";
import loanTypes from "../../../../constants/loanTypes";
import interestRateTypes from 'constants/interestRateTypes';
import dscrTypesConstants from "../../../../constants/dscrTypes";
import {
  ChildSectionTitle,
  SideLabelTextAreaWithRefInput,
  SideLabelPercentWithRefInput,
  SideLabelIntegerWithRefInput,
  SideLabelAutoCompleteWithRefInput,
  SideLabelDecimalInputWithRefInput,
  SideLabelHideablePercentWithRefInput,
  IndentedSideLabelIntegerWithRefInput,
  SideLabelAutoCompleteInput
} from "../FormSectionComponents";
import SideLabelDateWithDropdownInput from "../FormSectionComponents/SideLabelDateWithDropdownInput";

const StyledGrid = styled(Grid)`
  &&& {
    width: 1200px;
  }
`;

class FinancialCovenantsChildSection extends React.Component {
  isValueAdd = values => {
    const loanTypeId = _.get(values, "details.loanTypeId");
    return loanTypeId === loanTypes.VALUE_ADD;
  };
  
  shouldShowSuppFixedRateAssumption(formik){
    return formik.values.details.loanTypeId !== null && 
           formik.values.details.loanTypeId === loanTypes.FREDDIE_MAC && 
           formik.values.details.rateTypeId !== null &&
           formik.values.details.rateTypeId === interestRateTypes.FLOATING;
          }
          
  render() {
    const { formik, isEditing, dscrTypes } = this.props;
    const { values } = formik;
    
    const dscrStabilizedLabel = this.isValueAdd(values) ? "DSCR (Stabilized)" : "DSCR";
    const debtYieldStabilizedLabel = this.isValueAdd(values) ? "Debt Yield (Stabilized)" : "Debt Yield";
    const ltvStabilizedLabel = this.isValueAdd(values) ? "LTV (Stabilized)" : "LTV";

    const frequencyOptions = [
      {label: "One Time", value: "oneTime"},
      {label: "Monthly", value: "monthly"},
      {label: "Quarterly", value: "quarterly"},
      {label: "Semi Annually", value: "semiAnnually"},
      {label: "Annually", value: "annually"},
    ];
    return (
      <>
        <div id="covenants_section_financial_covenants">
          <ChildSectionTitle>Financial Covenants</ChildSectionTitle>
          <StyledGrid container alignItems="center" direction="column">
            {this.isValueAdd(values) && (
              <SideLabelDecimalInputWithRefInput
                label="DSCR (As-Is)"
                hasBorder
                placeholder="DSCR (As-Is)"
                fieldName="covenants.dscrAsIs"
                isDisabled={!isEditing}
              />
            )}
            <SideLabelDecimalInputWithRefInput
              label={dscrStabilizedLabel}
              hasBorder
              placeholder={dscrStabilizedLabel}
              fieldName="covenants.dscrStabilized"
              isDisabled={!isEditing}
            />
             <SideLabelDateWithDropdownInput 
              label="Testing Begins"
              dropdownLabel = "Frequency: "
              fieldName="covenants.dscrBeginTestingDate"
              dropdownFieldName="covenants.dscrFrequency"
              shouldIndent
              hasBorder
              options = {frequencyOptions}
              isDisabled={!isEditing}
            />
            <SideLabelTextAreaWithRefInput
              label="DSCR Covenants"
              hasBorder
              placeholder="DSCR Covenants"
              fieldName="covenants.dscrCovenants"
              isDisabled={!isEditing}
            />
            <SideLabelAutoCompleteInput
              label="DSCR Type"
              id="dropdownForDscrType"
              options={dscrTypes}
              selectName="name"
              selectValue="value"
              fieldName="covenants.dscrTypeId"
              hasBorder
              isDisabled={!isEditing}
            />
            {values.covenants && values.covenants.dscrTypeId === dscrTypesConstants.HYPOTHETICAL_AMORTIZATION && (
              <>
                <IndentedSideLabelIntegerWithRefInput
                  label="DSCR Amortization Term"
                  hasBorder
                  placeholder="DSCR Amortization Term"
                  fieldName="covenants.dscrAmortTerm"
                  isDisabled={!isEditing}
                  indentation={55}
                  shouldHideRef
                />
                <Grid container item style={{ paddingLeft: isEditing ? 16 : 55 }}>
                  <SideLabelHideablePercentWithRefInput
                    label="DSCR Fixed Rate"
                    hasBorder
                    placeholder="DSCR Fixed Rate"
                    fieldName="covenants.dscrFixedRate"
                    isDisabled={!isEditing}
                    decimalScale={3}
                    shouldHideRef
                  />
                  <SideLabelHideablePercentWithRefInput
                    label="DSCR Treasury Spread"
                    hasBorder
                    placeholder="DSCR Treasury Spread"
                    fieldName="covenants.dscrTreasurySpread"
                    isDisabled={!isEditing}
                    decimalScale={3}
                    shouldHideRef
                  />
                  <SideLabelHideablePercentWithRefInput
                    label="DSCR Floating Rate Spread"
                    hasBorder
                    placeholder="DSCR Floating Rate Spread"
                    fieldName="covenants.dscrFloatingRateSpread"
                    isDisabled={!isEditing}
                    decimalScale={3}
                    shouldHideRef
                  />
                </Grid>
              </>
            )}
            {values.covenants && values.covenants.dscrTypeId === dscrTypesConstants.ACTUAL_TRAILING_CASHFLOWS && (
              <IndentedSideLabelIntegerWithRefInput
                label="Trailing Months"
                hasBorder
                placeholder="Trailing Months"
                fieldName="covenants.dscrDebtServiceTerm"
                isDisabled={!isEditing}
                indentation={55}
                shouldHideRef
              />
            )}
            {values.covenants && values.covenants.dscrTypeId === dscrTypesConstants.ACTUAL_PROJECTED_CASHFLOWS && (
              <IndentedSideLabelIntegerWithRefInput
                label="Projected Months"
                hasBorder
                placeholder="Projected Months"
                fieldName="covenants.dscrDebtServiceTerm"
                isDisabled={!isEditing}
                indentation={55}
                shouldHideRef
              />
            )}
            {this.isValueAdd(values) && (
              <SideLabelPercentWithRefInput
                label="Debt Yield (As-Is)"
                hasBorder
                placeholder="Debt Yield (As-Is)"
                fieldName="covenants.debtYieldAsIs"
                isDisabled={!isEditing}
              />
            )}
            <SideLabelPercentWithRefInput
              label={debtYieldStabilizedLabel}
              hasBorder
              placeholder={debtYieldStabilizedLabel}
              fieldName="covenants.debtYieldStabilized"
              isDisabled={!isEditing}
            />
            <SideLabelDateWithDropdownInput 
              label="Testing Begins"
              dropdownLabel = "Frequency: "
              fieldName="covenants.debtYieldBeginTestingDate"
              dropdownFieldName="covenants.debtYieldFrequency"
              shouldIndent
              hasBorder
              options = {frequencyOptions}
              isDisabled={!isEditing}
            />
            <SideLabelTextAreaWithRefInput
              label="Debt Yield Covenants"
              hasBorder
              placeholder="Debt Yield Covenants"
              fieldName="covenants.debtYieldCovenants"
              isDisabled={!isEditing}
            />
            {this.isValueAdd(values) && (
              <SideLabelPercentWithRefInput label="LTV (As-Is)" hasBorder placeholder="LTV (As-Is)" fieldName="covenants.ltvAsIs" isDisabled={!isEditing} />
            )}
            <SideLabelPercentWithRefInput
              label={ltvStabilizedLabel}
              hasBorder
              placeholder={ltvStabilizedLabel}
              fieldName="covenants.ltvStabilized"
              isDisabled={!isEditing}
            />
             <SideLabelDateWithDropdownInput 
              label="Testing Begins"
              dropdownLabel = "Frequency: "
              fieldName="covenants.ltvBeginTestingDate"
              dropdownFieldName="covenants.ltvFrequency"
              shouldIndent
              hasBorder
              options = {frequencyOptions}
              isDisabled={!isEditing}
            />
            <SideLabelTextAreaWithRefInput
              label="LTV Covenants"
              hasBorder
              placeholder="LTV Covenants"
              fieldName="covenants.ltvCovenants"
              isDisabled={!isEditing}
            />
            <SideLabelPercentWithRefInput label="LTC" hasBorder placeholder="LTC" fieldName="covenants.ltc" isDisabled={!isEditing} />
            <SideLabelDateWithDropdownInput 
              label="Testing Begins"
              dropdownLabel = "Frequency: "
              fieldName="covenants.ltcBeginTestingDate"
              dropdownFieldName="covenants.ltcFrequency"
              shouldIndent
              hasBorder
              options = {frequencyOptions}
              isDisabled={!isEditing}
            />
            <SideLabelTextAreaWithRefInput
              label="LTC Covenants"
              hasBorder
              placeholder="LTC Covenants"
              fieldName="covenants.ltcCovenants"
              isDisabled={!isEditing}
            />
            <SideLabelPercentWithRefInput label="Occupancy" hasBorder placeholder="Occupancy" fieldName="covenants.occupancy" isDisabled={!isEditing} />
            <SideLabelDateWithDropdownInput 
              label="Testing Begins"
              dropdownLabel = "Frequency: "
              fieldName="covenants.occupancyBeginTestingDate"
              dropdownFieldName="covenants.occupancyFrequency"
              shouldIndent
              hasBorder
              options = {frequencyOptions}
              isDisabled={!isEditing}
            />
            <SideLabelTextAreaWithRefInput
              label="Occupancy Covenants"
              hasBorder
              placeholder="Occupancy Covenants"
              fieldName="covenants.occupancyCovenants"
              isDisabled={!isEditing}
            />
            { this.shouldShowSuppFixedRateAssumption(formik) &&
              <SideLabelPercentWithRefInput label="Supp Fixed Rate Assumption" hasBorder placeholder="Supp Fixed Rate Assumption" fieldName="covenants.suppFixedRateAssumption" isDisabled={!isEditing}/>
            }
            <SideLabelTextAreaWithRefInput label="Misc." placeholder="Misc." fieldName="covenants.financialCovenantsMisc" isDisabled={!isEditing} />

          </StyledGrid>
        </div>
      </>
    );
  }
}

const mapStateToProps = () => ({});

export default compose(connect, reduxConnect(mapStateToProps, {}))(FinancialCovenantsChildSection);
